import Sortable from 'stimulus-sortable'
import Rails from 'rails-ujs'

export default class extends Sortable {
  static targets = ['movieCard']

  static values = {
    updateUrl: String
  }

  connect() {
    super.connect()
  }

  end() {
    const moviePositions = this.movieCardTargets.map((movieCard, index) => {
      let id = movieCard.dataset.movieId
      let position = index

      return {id: id, position: position}
    })

    this.persistPositions(moviePositions)
  }

  get defaultOptions() {
    return {
      animation: 500,
      handle: '.move-handle'
    }
  }

  persistPositions(positions) {
    const formData = new FormData()

    positions.forEach(function ({id, position}) {
      formData.append(`movies[${position}][position]`, position)
      formData.append(`movies[${position}][id]`, id)
    })

    Rails.ajax({
      data: formData,
      type: 'PATCH',
      url: this.updateUrlValue
    })
  }
}
